import {
  CONFIRM_DIALOG_OPEN,
  CONFIRM_DIALOG_CLOSE
} from 'types/actions/confirm-dialog'

const confirmDialogInitialState = {
  open: false,
  data: {}
}

export default (state = confirmDialogInitialState, action) => {
  switch (action.type) {
    case CONFIRM_DIALOG_OPEN:
    case CONFIRM_DIALOG_CLOSE:
      return {
        ...state,
        open: action.open,
        data: action.data
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confirm-dialog.js